import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Deliverable endpoints
  createDeliverable: (data) => {
    return AxiosBusiness.post('deliverable', data)
  },

  updateDeliverable: (deliverableId, data) => {
    return AxiosBusiness.put(`deliverable/${deliverableId}`, data)
  },

  getDeliverable: (deliverableId) => {
    return AxiosBusiness.get(`deliverable/${deliverableId}`)
  },

  getAllDeliverablesByCustomer: (customerId, params) => {
    return AxiosBusiness.get(`deliverable/customer/${customerId}`, { params })
  },

  getAllDeliverablesByBillable: (billableId, params) => {
    return AxiosBusiness.get(`deliverable/billable/${billableId}`, { params })
  },

  deleteDeliverable: (deliverableId) => {
    return AxiosBusiness.delete(`deliverable/${deliverableId}`)
  }
}
